import { Box, Button } from '@mui/material';
import Iconify from 'src/components/iconify';

type BenefitType = 'coupon' | 'product';

type Props = {
  value: BenefitType;
  onChange: (value: BenefitType) => void;
  disabled?: boolean;
};

export default function BenefitTypeSelector({ value, onChange, disabled }: Props) {
  return (
    <Box
      role="group"
      aria-label="Tipo de benefício"
      sx={{
        p: 0.6,
        borderRadius: 1.5,
        backgroundColor: 'grey.100',
        border: '1px solid',
        borderColor: 'grey.300',
        display: 'inline-flex',
        gap: 0.8,
      }}
    >
      {[
        { value: 'coupon' as const, label: 'Cupom', icon: 'mdi:ticket-outline' },
        { value: 'product' as const, label: 'Produto', icon: 'mdi:cube-outline' },
      ].map((option) => {
        const selected = value === option.value;

        return (
          <Button
            key={option.value}
            variant={selected ? 'contained' : 'text'}
            color="inherit"
            disabled={disabled}
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            startIcon={<Iconify icon={option.icon} sx={{ width: 18, height: 18 }} />}
            sx={{
              minWidth: 120,
              px: 2,
              borderRadius: 1,
              color: selected ? 'text.primary' : 'text.secondary',
              backgroundColor: selected ? 'common.white' : 'transparent',
              boxShadow: selected ? 1 : 'none',
              '&:hover': {
                backgroundColor: selected ? 'common.white' : 'grey.200',
              },
            }}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
}
